import { Outlet } from "react-router-dom";

export default function WidgetsOutlet() {
  return <Outlet />;
}
